// src/lib/firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// Firebase config 객체
const firebaseConfig = {
  apiKey: "AIzaSyBBd8c8rfZMzqXDhmaay9E9NoZvuOgZ5RI",
  authDomain: "open-api-kyulabs.firebaseapp.com",
  projectId: "open-api-kyulabs",
  storageBucket: "open-api-kyulabs.firebasestorage.app",
  messagingSenderId: "105771766664",
  appId: "1:105771766664:web:3dc59449fe5a25a272203d",
  measurementId: "G-HHJQPL9NEB",
};

// Firebase 초기화
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics, logEvent };
